import React from "react";

const ForgotPassword = () => {
  return <h1>Forgot Password</h1>;
};

export default ForgotPassword;
